import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './search-decryption.actions';
import { SearchDecryptionState } from './search-decryption.state';

/**
 * searchDecryption initial state
 */
export const searchDecryptionInitialState: SearchDecryptionState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for SearchDecryption Store
 */
export const searchDecryptionReducerFeatures: ReducerTypes<SearchDecryptionState, ActionCreator[]>[] = [
  on(actions.setSearchDecryption, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateSearchDecryption, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetSearchDecryption, () => searchDecryptionInitialState),

  on(actions.cancelSearchDecryptionRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failSearchDecryption, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setSearchDecryptionFromApi, actions.updateSearchDecryptionFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * SearchDecryption Store reducer
 */
export const searchDecryptionReducer = createReducer(searchDecryptionInitialState, ...searchDecryptionReducerFeatures);
